import useOAuthGoogleLogin from '../../hooks/useOAuthGoogleLogin';
import { useEffect, useRef, useState } from 'react';
import OAuthLoading from './components/Loading';
import OAuthError from './components/Error';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/common/stores/auth';
import { useQueryClient } from '@tanstack/react-query';
import { getFromLocalStorage, setInLocalStorage } from '@/common/services/localStorageGetSet';

const OAuthGoogle = () => {
  const { updateAccessToken } = useAuth();

  const requested = useRef(false);

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [showError, setShowError] = useState(false);
  const [errorResponse, setErrorResponse] = useState('');

  const redirectTo = getFromLocalStorage('redirect_to');

  const {
    mutate: oauthGoogleLogin,
    isPending: isOauthGoogleLoginPending,
  } = useOAuthGoogleLogin({
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });

      setInLocalStorage('access-token', response.accessToken);
      updateAccessToken(response.accessToken);

      navigate(redirectTo || '/', { replace: true });

      localStorage.removeItem('redirect_to')
    },
    onError: (error) => {
      setShowError(true);

      if (error.response?.data?.errors?.base) {
        setErrorResponse(error.response?.data?.errors?.base[0])
      }
    }
  });

  useEffect(() => {
    if (!requested.current) {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      oauthGoogleLogin({ code });
    }
  }, []);

  return (
    <div className="flex flex-col items-center gap-8 w-screen">
      <img src="/Logo.svg" />

      {isOauthGoogleLoginPending && !showError && <OAuthLoading />}
      {showError && <OAuthError errorResponse={errorResponse} />}

      <div className="flex flex-col items-center">
        <span className="text-[10px] italic font-light">Desenvolvido por</span>
        <img src='/Avantsoft.svg' />
      </div>
    </div>
  );
}

export default OAuthGoogle;
